/* AppListing.styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _14 = "._awzo1ltq:not(:empty){max-height:16rem}";
const _13 = "._c71lidpf{max-height:0}";
const _12 = "._kqswh2mm{position:relative}";
const _11 = "._v5641cdp{transition:all .5s ease-in-out}";
const _10 = "._18m915vq{overflow-y:hidden}";
const _9 = "._1reo15vq{overflow-x:hidden}";
const _8 = "._2lx21bp4{flex-direction:column}";
const _7 = "._1e0c1txw{display:flex}";
const _6 = "._1yt41yrs{padding:0 0 var(--ds-space-800,64x) 0}";
const _5 = "._1tkebejm{min-height:31.25rem}";
const _4 = "._1bsb1osq{width:100%}";
const _3 = "._1yt41hdg{padding:var(--ds-space-400,2pc) 0 var(--ds-space-800,64x) 0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _2 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _ = "._19pk1jfw{margin-top:var(--ds-space-500,40px)}";
export const HostingSelectContainerV2 = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pk1jfw _otyru2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  HostingSelectContainerV2.displayName = 'HostingSelectContainerV2';
}
export const ListingContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pk1jfw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ListingContainer.displayName = 'ListingContainer';
}
export const TabContentContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41hdg _1bsb1osq _1tkebejm", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TabContentContainer.displayName = 'TabContentContainer';
}
export const TabEditionsContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = TabContentContainer,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41yrs", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TabEditionsContainer.displayName = 'TabEditionsContainer';
}
export const FAQWrapper = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  FAQWrapper.displayName = 'FAQWrapper';
}
export const AnimationContainer = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10, _11, _12, _13, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _v5641cdp _kqswh2mm _c71lidpf _awzo1ltq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AnimationContainer.displayName = 'AnimationContainer';
}